import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=273c7502&scoped=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AppSideMenu.vue?vue&type=style&index=0&id=273c7502&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c7502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273c7502')) {
      api.createRecord('273c7502', component.options)
    } else {
      api.reload('273c7502', component.options)
    }
    module.hot.accept("./AppSideMenu.vue?vue&type=template&id=273c7502&scoped=true", function () {
      api.rerender('273c7502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppSideMenu/AppSideMenu.vue"
export default component.exports